import React from "react";
import PageForm from "../form";

const About = ({ group }: { group: string }) => {
  return <PageForm title="About Us" Key={`${group}-about-us`} />;
};

export default About;
